module.exports = __webpack_public_path__ + "main/assets/public/button/right-arrow.2503ac3d158109ee.svg";